<template>
  <!-- <div class="container-fluid mt--6"> -->
  <div class="row">
    <div class="col">
      <div class="card">
        <!-- Card header -->
        <div class="card-header border-0">
          <h3 class="mb-0">All Users</h3>
        </div>
        <!-- Light table -->
        <div class="table-responsive">
          <table class="table align-items-center table-flush">
            <thead class="thead-light">
              <tr>
                <th scope="col" class="sort" data-sort="name">Username</th>
                <th scope="col" class="sort" data-sort="budget">Followers</th>
                <th scope="col" class="sort" data-sort="status">Following</th>
                <th scope="col">Email</th>
                <th scope="col" class="sort" data-sort="completion">
                  Phone Number
                </th>
                <th scope="col"></th>
              </tr>
            </thead>
            <template v-if="!loading && users.length > 0">
              <tbody class="list">
                <router-link
                  :to="{ name: 'UserProfile', params: { id: user._id } }"
                  tag="tr"
                  v-for="user in users"
                  :key="user._id"
                >
                  <th scope="row">
                    <div class="media align-items-center">
                      <!-- <a href="#" class="avatar rounded-circle mr-3">
                        <img
                          alt="Image placeholder"
                          src="/assets/img/theme/bootstrap.jpg"
                        />
                      </a> -->
                      <div class="media-body">
                        <span class="name mb-0 text-sm">{{
                          user.username
                        }}</span>
                      </div>
                    </div>
                  </th>
                  <td class="budget">
                    {{ user.followersCount }}
                  </td>
                  <td>
                    <span class="badge badge-dot mr-4">
                      <!-- <i class="bg-warning"></i> -->
                      <span class="status">{{ user.followingsCount }}</span>
                    </span>
                  </td>
                  <td>
                    {{ user.email }}
                  </td>
                  <td>
                    {{ user.phone_number }}
                  </td>
                  <td class="text-right">
                    <!-- <div class="dropdown">
                      <a
                        class="btn btn-sm btn-icon-only text-light"
                        href="#"
                        role="button"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <i class="fas fa-ellipsis-v"></i>
                      </a>
                      <div
                        class="dropdown-menu dropdown-menu-right dropdown-menu-arrow"
                      >
                        <a class="dropdown-item" href="#">Action</a>
                        <a class="dropdown-item" href="#">Another action</a>
                        <a class="dropdown-item" href="#"
                          >Something else here</a
                        >
                      </div>
                    </div> -->
                  </td>
                </router-link>
              </tbody>
            </template>
          </table>
        </div>
        <!-- Card footer -->
        <div class="card-footer py-4" v-if="!loading && users.length > 0">
          <nav aria-label="...">
            <ul class="pagination justify-content-end mb-0">
              <li class="page-item disabled">
                <a class="page-link" href="#" tabindex="-1">
                  <i class="fas fa-angle-left"></i>
                  <span class="sr-only">Previous</span>
                </a>
              </li>
              <li class="page-item active">
                <a class="page-link" href="#">1</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="#"
                  >2 <span class="sr-only">(current)</span></a
                >
              </li>
              <li class="page-item"><a class="page-link" href="#">3</a></li>
              <li class="page-item">
                <a class="page-link" href="#">
                  <i class="fas fa-angle-right"></i>
                  <span class="sr-only">Next</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
        <div v-if="!loading && users.length === 0">
          <p>No users</p>
        </div>
        <div v-if="loading" class="nt">
          <ClipLoader :loading='loading'></ClipLoader>
        </div>
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
export default {
  name: 'Users',
  data () {
    return {
      users: [],
      loading: false
    }
  },
  mounted () {
    this.getUsers()
  },
  methods: {
    async getUsers () {
      this.loading = true
      try {
        const res = await this.$store.dispatch('users/getUsers')
        if (!res) return
        this.loading = false
        this.users = res.data
        console.log(res.data)
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style scoped>
tr {
  cursor: pointer;
}
.nt {
  margin: 30px 0;
}
</style>
